// Texts of the store locator audit results.
//
// `importance` comes from the API as the code "Haute" | "Moyenne" | "Basse" in
// both languages (used for sorting and the CSS class); `importance` below maps
// it to the label shown to the visitor.
const content = {
  fr: {
    dateLocale: "fr-FR",
    auditDate: (date) => `Audit réalisé le ${date}`,
    partialTitle: "Synthèse IA indisponible",
    partialMsg:
      "L'analyse IA (forces, faiblesses, recommandations) n'a pas pu être finalisée. Votre score global et le détail des critères restent disponibles ci-dessous.",
    previewAlt: (url) => `Aperçu ${url}`,
    goodCount: (n) => `${n} OK`,
    badCount: (n) => `${n} à améliorer`,
    strengths: "Forces",
    weaknesses: "Faiblesses",
    recommendations: "Recommandations",
    demoBadge: "Expert SEO local",
    demoTitle: "Besoin d'aide pour implémenter ces recommandations ?",
    demoDesc:
      "Échangez avec un expert Localranker pour optimiser vos pages locales et booster votre visibilité.",
    demoCta: "Demander une démo gratuite",
    criteriaTitle: "Détail des critères",
    sort: {
      importance: "Importance",
      scoreAsc: "Score ↑",
      scoreDesc: "Score ↓",
    },
    lockedCount: (n) => `+ ${n} critères masqués`,
    unlock: "Débloquer l'audit complet",
    observation: "Observation",
    recommendation: "Recommandation",
    importance: { Haute: "Haute", Moyenne: "Moyenne", Basse: "Basse" },
  },
  en: {
    dateLocale: "en-US",
    auditDate: (date) => `Audit run on ${date}`,
    partialTitle: "AI summary unavailable",
    partialMsg:
      "The AI analysis (strengths, weaknesses, recommendations) could not be completed. Your overall score and the criteria breakdown are still available below.",
    previewAlt: (url) => `Preview of ${url}`,
    goodCount: (n) => `${n} OK`,
    badCount: (n) => `${n} to improve`,
    strengths: "Strengths",
    weaknesses: "Weaknesses",
    recommendations: "Recommendations",
    demoBadge: "Local SEO expert",
    demoTitle: "Need help putting these recommendations in place?",
    demoDesc:
      "Talk to a Localranker expert about optimizing your location pages and growing your local visibility.",
    demoCta: "Book a free demo",
    criteriaTitle: "Criteria breakdown",
    sort: {
      importance: "Priority",
      scoreAsc: "Score ↑",
      scoreDesc: "Score ↓",
    },
    lockedCount: (n) => `+ ${n} more criteria hidden`,
    unlock: "Unlock the full audit",
    observation: "Finding",
    recommendation: "Recommendation",
    importance: { Haute: "High", Moyenne: "Medium", Basse: "Low" },
  },
};

export default content;
